// begin content load more animation code
var show_more = document.querySelectorAll(".btn-show-more");
var content = document.querySelectorAll(".show-more-container");

window.addEventListener("load", function() {
  show_more_func()
})

window.addEventListener("resize", function() {
  show_more_func()
})

function show_more_func() {
  content.forEach(item => {
    var button = item.querySelector(".btn-show-more")
    if(button.previousElementSibling.childNodes[0].clientHeight >= parseInt(button.closest(".show-more-container").getAttribute("data-content-height"))) {
      item.classList.add("show")
    }else {
      item.classList.remove("show")
    }
  })
}

document.querySelectorAll(".btn-show-more").forEach(button => {
  button.addEventListener("click", function() {
    if(this.innerHTML == "Lees meer") {
      this.innerHTML = "lees minder";
      this.previousElementSibling.style.maxHeight = (this.previousElementSibling.childNodes[0].clientHeight + 30) + "px"
    }else {                                                                                                   
      this.innerHTML = "Lees meer";
      this.previousElementSibling.style.maxHeight = this.closest(".show-more-container").getAttribute("data-content-height") + "px"
    }
  })
});

// end content load more animation code




document.addEventListener('DOMContentLoaded',() => {

// begin Global Read More 
let readMoreContainers =  document.querySelectorAll('.js-read-more')
let readMoreButtons =  document.querySelectorAll('.js-toogle-read-more')
function resetReadMore(){
  readMoreContainers.forEach( container => {
    let desktopHeight = container?.dataset.height || 200
    let mobileHeight = container?.dataset.mobileHeight || 200
    let button = container?.closest('.read-more-container').querySelector('.js-toogle-read-more');
    let readMoreContent = container?.querySelector('.js-read-more-content')
    let contentHeight = readMoreContent.getBoundingClientRect().height
    if( window.innerWidth >= 768) {
      if( desktopHeight <= contentHeight) {
        button.classList.remove('hidden')
      }else {
        button.classList.add('hidden')
      }
    }else {
      if( mobileHeight <= contentHeight) {
        button.classList.remove('hidden')
        
      }else {
        button.classList.add('hidden')
      }
    }
    if(container.classList.contains('open')) {
      container.style.maxHeight = contentHeight + "px"
    }else {
      if(window.innerWidth <= 768) {
        container.style.maxHeight = desktopHeight + "px"
      }else {
        container.style.maxHeight = mobileHeight + "px"
      }
    }
  })
}
readMoreButtons.forEach( button => {
  button.addEventListener('click',(e) => {
    e.preventDefault()
    let readMoreContent = button?.closest('.read-more-container').querySelector('.js-read-more');
    readMoreContent.classList.toggle('open')
    resetReadMore()
  })
})
resetReadMore()
window.addEventListener("resize", function() {
  resetReadMore()
})

// End Global Read more


// Began Incl price checkbox

let  inclCheckboxState = localStorage.getItem(`${ Shopify.shop}-inclCheckboxState`)
let  inclCheckboxDefaultState = 'true'; 

if(!inclCheckboxState) {
// set VAT included on default
localStorage.setItem(`${ Shopify.shop}-inclCheckboxState`, inclCheckboxDefaultState )
inclCheckboxUpdate(inclCheckboxDefaultState);
updateCheckboxState();
}else {
inclCheckboxUpdate(inclCheckboxState);
updateCheckboxState();
}

function inclCheckboxUpdate(inclCheckboxState) {
if(inclCheckboxState == 'true') {
  document.querySelector('#ani-checkbox-modal').checked =  true
}else if(inclCheckboxState == 'false') {
  document.querySelector('#ani-checkbox-modal').checked =  false
}
}

document.querySelector('#ani-checkbox-modal')?.addEventListener('change',(e)=>{
localStorage.setItem(`${ Shopify.shop}-inclCheckboxState`,document.querySelector('#ani-checkbox-modal')?.checked )
inclCheckboxState = document.querySelector('#ani-checkbox-modal').checked 
inclCheckboxUpdate(inclCheckboxState)
})

// end Incl price checkbox
});

// Function to update the checkbox state and text based on the current checkbox state
function updateCheckboxState() {
const checkbox = document.querySelector('#ani-checkbox-modal'); // Select the checkbox
const labelText = document.querySelector('.nf-incl-vat-header'); // Select the text element

if (checkbox && labelText) {
  if (checkbox.checked) {
    labelText.textContent = 'Incl. btw'; // Change text to "Incl. BTW" when checked
    localStorage.setItem(`${Shopify.shop}-inclCheckboxState`, 'true'); // Save state to localStorage
      } else {
    labelText.textContent = 'Excl. btw'; // Change text to "Excl. BTW" when unchecked
    localStorage.setItem(`${Shopify.shop}-inclCheckboxState`, 'false'); // Save state to localStorage
  }
}
}

// Event listener for checkbox change
document.querySelector('#ani-checkbox-modal')?.addEventListener('change', updateCheckboxState);